// noteBookmarkVerseListReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  book4Accordion1: 0, // Default value
  chapter4Accordion1: 0,
  verse4Accordion1: 0,
  bookChapter2: { book: 0, chapter: 0 },
  bookChapterList2: [], // Default value
  verseList4Accordion1: [],
  noteBookmarkVerseList: [],
};

const noteBookmarkVerseListSlice = createSlice({
  name: 'noteBookmarkVerseList',
  initialState,
  reducers: {
    setBook4Accordion1(state, action) {
      state.book4Accordion1 = action.payload;
    },
    setChapter4Accordion1(state, action) {
      state.chapter4Accordion1 = action.payload;
    },
    setBookChapter2(state, action) {
      state.bookChapter2 = action.payload;
    },
    setBookChapterList2(state, action) {
      state.bookChapterList2 = action.payload;
    },
    setVerse4Accordion1(state, action) {
      state.verse4Accordion1 = action.payload;
    },
    setVerseList4Accordion1(state, action) {
      state.verseList4Accordion1 = action.payload;
    },
    setNoteBookmarkVerseList(state, action) {
      state.noteBookmarkVerseList = action.payload;
    },
    reset4NoteBookmarkVerseList() {
      return initialState;
    },
  },
});

export const { setBook4Accordion1, setChapter4Accordion1, setBookChapter2, setBookChapterList2, setVerse4Accordion1, setVerseList4Accordion1, setNoteBookmarkVerseList, reset4NoteBookmarkVerseList } = noteBookmarkVerseListSlice.actions;
export default noteBookmarkVerseListSlice.reducer;
// const initialState = {
//   //loading4Accordion1: false,
//   book4Accordion1: 0, // Default value
//   chapter4Accordion1: 0,
//   verse4Accordion1: 0,
//   bookChapter2: { book: 0, chapter: 0 },
//   bookChapterList2: [], // Default value
//   verseList4Accordion1: [],
//   noteBookmarkVerseList: [],
// };

// export default function noteBookmarkVerseListReducer(state = initialState, action) {
//   switch (action.type) {
//     // case 'setLoading4Accordion1':
//     //   return {
//     //     ...state,
//     //     loading4Accordion1: action.payload, // Update the selected book
//     //   };    
//     case 'setBook4Accordion1':
//       return {
//         ...state,
//         book4Accordion1: action.payload, // Update the selected book
//       };
//     case 'setChapter4Accordion1':
//       return {
//         ...state,
//         chapter4Accordion1: action.payload,
//       };      
//     case 'setBookChapter2':
//       return {
//         ...state,
//         bookChapter2: action.payload,
//       };    
//     case 'setBookChapterList2':
//       return {
//         ...state,
//         bookChapterList2: action.payload,
//       };       
//     case 'setVerse4Accordion1':
//       return {
//         ...state,
//         verse4Accordion1: action.payload,
//       };   
//     case 'setVerseList4Accordion1':
//       return {
//         ...state,
//         verseList4Accordion1: action.payload,
//       };      
//     case 'setNoteBookmarkVerseList':
//       return {
//         ...state,
//         noteBookmarkVerseList: action.payload,
//       };                  
//     case 'reset4NoteBookmarkVerseList':
//       return initialState;     
//     default:
//       return state;
//   }
// }

// // export const setLoading4Accordion1 = (e) => ({
// //   type: 'setLoading4Accordion1',
// //   payload: e,
// // });

// export const setBook4Accordion1 = (e) => ({
//   type: 'setBook4Accordion1',
//   payload: e,
// });

// export const setChapter4Accordion1 = (e) => ({
//   type: 'setChapter4Accordion1',
//   payload: e,
// });

// export const setBookChapter2 = (e) => ({
//   type: 'setBookChapter2',
//   payload: e,
// });

// export const setBookChapterList2 = (e) => ({
//   type: 'setBookChapterList2',
//   payload: e,
// });

// export const setVerse4Accordion1 = (e) => ({
//   type: 'setVerse4Accordion1',
//   payload: e,
// });

// export const setVerseList4Accordion1 = (e) => ({
//   type: 'setVerseList4Accordion1',
//   payload: e,
// });

// export const setNoteBookmarkVerseList = (e) => ({
//   type: 'setNoteBookmarkVerseList',
//   payload: e,
// });

// export const reset4NoteBookmarkVerseList  = (e) => ({
//   type: 'reset4NoteBookmarkVerseList',
//   payload: e,
// });